import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    style: {"width":"100vw"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "ml-5" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("h1", null, "Tickets Z", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "mr-3 d-flex justify-end" }, {
            default: _withCtx(() => [
              (_ctx.currentUser.profile.configuration.document.write)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    rounded: "",
                    color: "primary",
                    onClick: _ctx.newTicketZ,
                    "data-cy": "zTillReceipts-create"
                  }, {
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createTextVNode(" Ajouter ")),
                      _createVNode(_component_v_icon, { class: "margin-left-small" }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("$fa-plus")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              cols: "12",
              key: index,
              class: "py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "default_card ma-0 pa-2",
                  elevation: "0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "10",
                          class: "font-weight-bold subtitle-1 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getDate(item.date)) + " - " + _toDisplayString(item.period), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_ctx.enableDelete(item))
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_trash, {
                                  onClick: ($event: any) => (_ctx.deleteZTill(item)),
                                  size: "small"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.netAmount ? _ctx.mathFix(item.netAmount) + " €" : "-"), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.vatAmount ? _ctx.mathFix(item.vatAmount) + " €" : "-"), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "font-weight-bold d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.grossAmount ? _ctx.mathFix(item.grossAmount) + " €" : "-"), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_DocumentWizardDialog, {
        active: _ctx.newZTillReceipt,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newZTillReceipt) = $event)),
        companyId: _ctx.selectedCompany.id,
        showFirstPrevious: false,
        inGlobalStep: 'zTillReceipt',
        onCreated: _ctx.onZTillReceiptCreated
      }, null, 8, ["active", "companyId", "onCreated"])
    ]),
    _: 1
  }))
}